var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexy pb-2"},[_c('div',{staticClass:"is-clearfix"}),_c('loading-info'),_c('div',{staticClass:"pt-4",staticStyle:{"margin-top":"10px"}},[_c('FullCalendar',{attrs:{"options":{
                ..._vm.calendarOptions,
                events: _vm.events,
            }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }